import {
  UI_COLOR_BORDER_TABLE,
  UI_COLOR_PRIMARY_EMPHASIS,
  UI_COLOR_TEXT_DISABLED_DARK,
  UI_COLOR_TEXT_MUTED_LIGHT,
  UI_COLOR_WHITE
} from '../../../constants/uiColors'

export const METRICS_FILTER_TITLE_SX = {
  mb: 1
}

export const METRICS_FILTER_BAR_SX = {
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1
}

export const METRICS_BUYER_FILTER_SX = {
  width: 130
}

export const METRICS_PRODUCT_GROUP_FILTER_SX = {
  width: 230
}

export const METRICS_RESET_FILTER_WRAPPER_SX = {
  mt: 2,
  mb: -0.75
}

export const METRICS_RESET_FILTER_TEXT_SX = {
  marginTop: '0 !important'
}

export const METRICS_HEADER_SX = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  mb: 2,
  mt: 3,
  px: '75px',
  pr: '95px'
}

export const METRICS_HEADER_TITLE_SX = {
  fontSize: 28
}

export const METRICS_HEADER_EXPORT_SX = {
  minWidth: 286,
  '& .MuiButton-root': {
    height: 37
  }
}

export const EXPORT_BUTTON_ICON_COLOR = UI_COLOR_WHITE

export const EXPORT_BUTTON_DISABLED_ICON_COLOR = UI_COLOR_TEXT_DISABLED_DARK

export const EXPORT_SPLIT_ARROW_BUTTON_SX = {
  minWidth: 36,
  px: 0
}

export const METRICS_SUMMARY_GRID_SX = {
  display: 'grid',
  gridTemplateColumns:
    'repeat(auto-fit, minmax(clamp(220px, 20vw, 300px), 1fr))',
  gap: 2
}

export const METRICS_SUMMARY_CARD_SX = {
  backgroundColor: UI_COLOR_WHITE,
  border: `2px solid ${UI_COLOR_BORDER_TABLE}`,
  borderRadius: 3,
  height: 120
}

export const METRICS_SUMMARY_CARD_CONTENT_SX = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-between',
  p: 2.5
}

export const METRICS_SUMMARY_CARD_TITLE_SX = {
  fontSize: 13,
  fontWeight: 700
}

export const METRICS_SUMMARY_CARD_CHIP_SX = {
  ml: 'auto'
}

export const METRICS_SUMMARY_CARD_SUBTITLE_SX = {
  color: UI_COLOR_TEXT_MUTED_LIGHT,
  fontSize: 12
}

export const METRICS_SUMMARY_CARD_VALUE_SX = {
  color: UI_COLOR_PRIMARY_EMPHASIS,
  fontSize: 30,
  fontWeight: 800,
  lineHeight: 1
}
